import { orpc } from "@/utils/orpc.client";

export function getStoresQueryOptions() {
  return orpc.deals.getStores.queryOptions({});
}
